import styled from '@emotion/styled';
import { useRef } from 'react';
import useMounted from '@hooks/useMounted';
import { mobile, Spacings } from '@styles/index';
import { sectionsIds } from './sections';
import SummitHeader from './SummitHeader/SummitHeader';
import SummitStats from './SummitStats/SummitStats';
import SummitEvents from './SummitEvents/SummitEvents';
import SummitSchedule from './SummitSchedule/SummitSchedule';
import SummitShare from './SummitShare/SummitShare';
import SummitFaqs from './SummitFaqs/SummitFaqs';
import SummitFooter from './SummitFooter/SummitFooter';
import SummitSpeakers from './SummitSpeakers/SummitSpeakers';

const SummitContainer = styled.div`
  background-color: var(--color-base-0);
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  grid-row-gap: 240px;
  padding-bottom: ${Spacings.SPACING_20B};
  overflow-x: hidden;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    display: block;
    padding-bottom: 0px;
  }
`;

const Summit = () => {
  const isMounted = useMounted();
  const headerRefs = {
    [sectionsIds.events]: useRef(),
    [sectionsIds.faqs]: useRef(),
    [sectionsIds.schedule]: useRef(),
    [sectionsIds.speakers]: useRef()
  };

  return (
    <SummitContainer>
      <SummitHeader headerRefs={headerRefs} isPageReady={isMounted} />
      <SummitStats />
      <SummitEvents headerRefs={headerRefs} />
      <SummitSpeakers headerRefs={headerRefs} />
      <SummitSchedule headerRefs={headerRefs} />
      <SummitShare />
      <SummitFaqs headerRefs={headerRefs} />
      <SummitFooter scheduleRef={headerRefs[sectionsIds.schedule]} />
      {/* <BaseFooter display /> */}
    </SummitContainer>
  );
};

export default Summit;
